import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-flixs-skeleton',
  templateUrl: './flixs-skeleton.component.html',
  styleUrls: ['./flixs-skeleton.component.css']
})

export class FlixsSkeletonComponent implements OnInit {
  @Input() showHero: boolean = false;
  @Input() showVideo: boolean = true;
  @Input() sectionsCount: number = 5;
  @Input() itemsPerSection: number = 8;
  
  sections: number[] = [];
  items: number[] = [];
  
  constructor() { }
  
  ngOnInit(): void {
    this.sections = Array(this.sectionsCount).fill(0);
    this.items = Array(this.itemsPerSection).fill(0);
  }
}
